module.exports = __webpack_public_path__ + "static/dinestination-8d178596701e2acb874e327084004a27.png";